import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import 'react-widgets/dist/css/react-widgets.css';
import Loader from 'react-loader-spinner';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

var monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
];

class SupervisorySessions extends Component {
    constructor() {
        super();
        this.state = {
            successResp: false,
            data: [],
            selectedDate: new Date()
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchSupervisorySessionDetailsApi();
        }, 300);

        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.fetchSupervisorySessionDetailsApi(event.projectId);
        });
    }

    fetchSupervisorySessionDetailsApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        let supervisorySessionCom = this;
        let selectedDate = supervisorySessionCom.state.selectedDate;
        let longDate = new Date(selectedDate.toDateString()).getTime();
        $.ajax({
            url: "/api/user-session-info-support-team",
            async: false,
            method: 'GET',
            data: {
                "projectId": projectId,
                "date": longDate
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    supervisorySessionCom.state.data = res.result;
                    for (var i = 0; i < res.result.length; i++) {
                        const loginTime = res.result[i].loginTime == 0 ? 0 : new Date(res.result[i].loginTime)
                        const logoutTime = res.result[i].logoutTime == 0 ? 0 : new Date(res.result[i].logoutTime)
                        supervisorySessionCom.state.data[i].loginTime = loginTime == 0 ? "-" : loginTime.getDate() + "/" + parseInt(loginTime.getMonth() + 1) + "/" + loginTime.getFullYear() + " " + loginTime.getHours() + ":" + loginTime.getMinutes() + ":" + loginTime.getSeconds();
                        supervisorySessionCom.state.data[i].logoutTime = logoutTime == 0 ? "-" : logoutTime.getDate() + "/" + parseInt(logoutTime.getMonth() + 1) + "/" + logoutTime.getFullYear() + " " + logoutTime.getHours() + ":" + logoutTime.getMinutes() + ":" + logoutTime.getSeconds();
                    }
                    supervisorySessionCom.state.successResp = true;
                    supervisorySessionCom.setState(supervisorySessionCom.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    onDateChange = (date) => {
        this.state.selectedDate = date;
        this.setState(this.state);
        this.fetchSupervisorySessionDetailsApi();
    }

    refreshData = () => {
        this.fetchSupervisorySessionDetailsApi()
    }

    render() {
        const { data } = this.state
        const columns = [
            {
                Header: <b>User Name</b>,
                textAlign: 'screenLeft',
                accessor: 'userName',
                sortable: false,
                Cell: props => {
                    return (
                        (<div
                            Align="left" className="input"
                            style={{
                                padding: '8px', width: '98%', borderBottom: 'none',
                                border: 'none', paddingLeft: '2px'
                            }}
                            suppressContentEditableWarning
                            contentEditable={false}
                            type="text">{props.original.username}</div>)
                    )
                },
            }, {
                Header: <b>User Email ID</b>,
                accessor: 'useEmailId',
                sortable: false,
                Cell: props => {
                    return (<div
                        Align="left" className="input"
                        style={{
                            padding: '8px', width: '98%', borderBottom: 'none',
                            border: 'none', paddingLeft: '2px'
                        }}
                        suppressContentEditableWarning
                        contentEditable={false}
                        type="text">{props.original.userEmailId}</div>)
                },
            }, {
                Header: <b>Mobile Number</b>,
                accessor: 'mobileNumber',
                sortable: false,
                Cell: props => {
                    return (<div
                        Align="left" className="input"
                        style={{
                            padding: '8px', width: '98%', borderBottom: 'none',
                            border: 'none', paddingLeft: '2px'
                        }}
                        suppressContentEditableWarning
                        contentEditable={false}
                        type="text">{props.original.userMobileNumber}</div>)
                },
            }, {
                Header: <b>Login Time</b>,
                accessor: 'loginTime',
                sortable: false,
                Cell: props => {
                    const loginTime = props.original.loginTime == 0 ? 0 : props.original.loginTime
                    return (<div
                        Align="left" className="input"
                        style={{
                            padding: '8px', width: '98%', borderBottom: 'none',
                            border: 'none', paddingLeft: '2px'
                        }}
                        suppressContentEditableWarning
                        contentEditable={false}
                        type="text">{loginTime}</div>)
                },
            }, {
                Header: <b>Logout Time</b>,
                accessor: 'logoutTime',
                sortable: false,
                Cell: props => {
                    const logoutTime = props.original.logoutTime == 0 ? 0 : props.original.logoutTime
                    return (<div
                        Align="left" className="input"
                        style={{
                            padding: '8px', width: '98%', borderBottom: 'none',
                            border: 'none', paddingLeft: '2px'
                        }}
                        suppressContentEditableWarning
                        contentEditable={false}
                        type="text">{logoutTime}</div>)
                },
            }
        ]
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!this.state.successResp}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />

                <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }} className="container-fluid">

                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />

                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-6">
                                <h6 className="nav-item" style={{
                                    color: '#282a65',
                                    marginTop: '24px', marginLeft: '2px'
                                }}>Supervisors - Last Login Information</h6>
                            </div>
                            {/* refresh button*/}
                            <div className="col-sm-6 p-0" align="right">
                                <div className="d-flex flex-row-reverse pt-2">
                                    <button onClick={this.refreshData} className="btn action-button" title="Refresh">
                                        <img src="./assets/images/refresh_white_24dp.png"></img>
                                    </button>
                                    <div align='right'>
                                        <DatePicker
                                            id="date"
                                            selected={this.state.selectedDate}
                                            onChange={this.onDateChange}
                                            dateFormat="dd/MM/yyyy">
                                        </DatePicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row" >
                                <div className="col-lg-12 ">
                                    <div className="card" >
                                        <ReactTable
                                            data={data}
                                            columns={columns}
                                            defaultPageSize={5}
                                            pageSizeOptions={[5, 10, 15]}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )

    }
}

export default SupervisorySessions;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/audit/SupervisorySessions.js